import React from 'react'
import { useTranslation } from 'react-i18next';
import HomeMainTitle from '../../../homeTitle/HomeMainTitle'

const CompanyAboutus = ({data}) => {
    const {t} = useTranslation();

    return (
        <div className='CompanyAboutus animate__animated animate__fadeInDown'>
            {data.profile &&
                data.profile.description ?
                    <>
                        <HomeMainTitle>{t("dashboard_nav_about_company")}</HomeMainTitle>
                        <p className='text-center'>{data.profile.description}</p>
                    </>
                :
                   ''
            }
        </div>
    )
}

export default CompanyAboutus
